<modal-sidebar
	[visible]="isOpen"
	(closeModal)="cancel()"
	[closeOnClickOutside]="false"
>
	<div header class="sidebar__header">
		<div class="zk-my-4 zk-gap-2 zk-flex zk-items-center">
			<span class="sidebar__title">{{
				!sidebar?.id
					? ('APPOINTMENTS.NEW' | translate)
					: ('APPOINTMENTS.EDIT' | translate)
			}}</span>
			<div
				*ngIf="action === 'create'"
				freud-tooltip
				[tooltipLabel]="'APPOINTMENTS.TOOLTIP' | translate"
				tooltipPosition="bottom"
			>
				<span class="freud-icon freud-icon-info-circle freud-icon-md"></span>
			</div>
		</div>
		<freud-select-button [options]="tabs" [selectedOption]="selectedTab" (selectedOptionChange)="changeTab($event.value)"
			iconPosition="append" [autoOverflow]="true"></freud-select-button>
	</div>
	<div body>
		<div class="zk-relative">
			<appointment-form
				*ngIf="isOpen"
				(onFormInit)="setFormInstance($event)"
				[type]="selectedTab"
				[value]="formValue"
				[action]="action"
				[isReposition]="isAppointmentReposition"
				[invalidAppointmentNoShowSelected]="invalidAppointmentNoShowSelected"
				[isUserPremium]="isUserPremium"
			></appointment-form>
			<div class="loader__wrapper" *ngIf="isLoading">
				<freud-loader></freud-loader>
			</div>
		</div>
	</div>
	<div footer class="zk-flex zk-gap-2 zk-justify-end zk-p-5">
		<freud-button color="secondary" [disabled]="isLoading" (click)="cancel(true)">{{
			'APPOINTMENTS.CANCEL' | translate
		}}</freud-button>
		<freud-button (click)="schedule()" [disabled]="isLoading">{{
			action === 'edit' ? ('APPOINTMENTS.EDIT_APPOINTMENT' | translate) : ('APPOINTMENTS.SCHEDULE' | translate)
		}}</freud-button>
	</div>
</modal-sidebar>

<!-- CONFIRM EDIT BUSY SLOT MODAL -->
<confirm-action-busy-slot
	(onChangeOption)="setOptionToEditBusySlot($event)"
	(onConfirmOption)="confirmEditBusySlot($event)"
	[open]="confirmEditBusySlotModal"
></confirm-action-busy-slot>
<conflict-invite-new-appointment-modal
	[isVisible]="conflictInviteNewAppointmentError.showModal"
	[busySlots]="conflictInviteNewAppointmentError.busySlots"
	[appointment]="conflictInviteNewAppointmentError.appointmentToCreate"
	(onConfirm)="confirmConflictInviteNewAppointment($event)"
	(onClose)="closeConflictInviteNewAppointmentModal()"
></conflict-invite-new-appointment-modal>
